import React from 'react';
import ReactDOM from 'react-dom';
import './title.css';

class Title extends React.Component {
  render(){
    return(
    <h1>{this.props.title}</h1>
   );
  }

}

export default Title;



// WEBPACK FOOTER //
// ./src/title/title.js